import store from '../reducers'
import events from 'actions/events'
import { PageActions, ConfigActions } from 'actions'

export default () => {
    ConfigActions.append({
        hideBackButton: true
    })

    events.on('Filters.componentDidSubmit',()=>{
        if(store.getState().session.accountID){
            PageActions.navToTimeSlots()
        } else {
            PageActions.navToCollectInformation()
        }
    })
    
    events.on('TimeSlots.componentDidSubmit',()=>{
        PageActions.navToCollectInformation()
    })

    events.on('ContactInformation.componentDidSubmit',()=>{
        if(!store.getState().selectedTimeSlot.id){
            PageActions.navToTimeSlots()
        }
    })


    events.on('PatientInformation.componentDidSubmit',()=>{
        let finishedPatientIDs = []
        Object.keys(store.getState().patients).forEach((key)=>{
            let patient = store.getState().patients[key]
            if(!/newPatient/.test(key) && 
                Object.keys(store.getState().selectedPatients).includes(patient.id) && 
                patient.reason){
                    finishedPatientIDs.push(patient.id)
            }
        })
        if(finishedPatientIDs.length == store.getState().filters.patientCount){
            PageActions.navToPayment()
        }
    })
    
    events.on('CollectInformation.componentDidSubmit',()=>{
        PageActions.navToPayment()
    })
    
    events.on('Payment.componentDidSubmit',()=>{
        PageActions.navToConfirmation()
    })    

    events.on('Confirmation.componentDidSubmit',()=>{
        PageActions.navToReceipt()
    })
}


// WEBPACK FOOTER //
// ./eventFlows/allUserValidCard.js